
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.797","height":"10.797"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_45760","data-name":"Group 45760","transform":"translate(-336.475 -159.484)"}},[_c('g',{attrs:{"id":"Group_45759","data-name":"Group 45759","transform":"translate(337.225 160.203)"}},[_c('g',{attrs:{"id":"Group_42930","data-name":"Group 42930","transform":"translate(0 4.663)"}},[_c('g',{attrs:{"id":"Group_42931","data-name":"Group 42931"}},[_c('path',{attrs:{"id":"Path_29830","data-name":"Path 29830","d":"M9.328.001L0 0h9.3","fill":"none","stroke":"#969caf","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])]),_c('g',{attrs:{"id":"Group_43256","data-name":"Group 43256","transform":"rotate(-90 6.996 2.332)"}},[_c('g',{attrs:{"id":"Group_42931-2","data-name":"Group 42931"}},[_c('path',{attrs:{"id":"Path_29830-2","data-name":"Path 29830","d":"M9.328 0H0h9.3","fill":"none","stroke":"#969caf","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])])])])
          )
        }
      }
    